<app-panel class="action-menu-panel" panelId="PROMPT_SUGGESTIONS_LIST_PANEL">
    <h2 [attr.data-qa]="'panel-title'" class="panel-section-headline">{{ 'PROMPT_SUGGESTIONS_PANEL_TITLE' | translate }}</h2>
    <div class="action-menu-panel-content action-menu-panel-content-scrollable">
        @if (isLoading()) {
            <app-loading-spinner [loadingText]="'GENERATING_PROMPT_SUGGESTIONS' | translate" data-qa="generating-prompts-loading-spinner"/>
        } @else {
            <ul class="list">
                @for (suggestion of promptSuggestions(); track i; let i = $index) {
                    <li>
                        <button (click)="sendChatMessage(suggestion.prompt)" [attr.data-qa]="'prompt-suggestion-' + i" class="button button-list-item list-item">
                            <app-icon [iconSize]="AppIconSizeEnum.MEDIUM" [svgIcon]="ICONS.CHAT_AI" aria-hidden="true" class="list-item-icon"/>
                            <div class="list-item-text list-item-title suggestion-text">{{ suggestion.prompt }}</div>
                        </button>
                    </li>
                }
            </ul>
        }
    </div>
    <div class="action-menu-panel-buttons">
        <app-button (clicked)="closePanel()"
                    [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                    [buttonText]="'BUTTON.CLOSE' | translate"
                    [svgIcon]="ICONS.CLOSE"
                    qaTag="close-prompt-suggestions-panel"/>
    </div>
</app-panel>
